import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  IrspaLetterContentComponentConfig, IrspaLetterContentSectionComponent
} from '../common/irspa-letter-content-section/irspa-letter-content-section.component';
import {
  IrspaDetailedInformationOnTheLetterContentComponentConfig, IrspaDetailedInformationOnTheLetterContentSectionComponent
} from '../common/irspa-detailed-information-on-the-letter-content-section/irspa-detailed-information-on-the-letter-content-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Treść pisma',
  'Szczegółowe informacje dotyczące treści pisma',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  cancelUrl: '../wnioskodawca',
  successUrl: '../tresc-pisma',
  addActTypeControl: true,
  hideDocumentReceiptMethodControl: true
};

export const irspaLetterContentComponentConfig: IrspaLetterContentComponentConfig = {
  stages,
  successUrl: '../szczegolowe-informacje-dotyczace-tresci-pisma',
  cancelUrl: '../dane-wniosku',
  defaultShipmentTypeValue: 'Uwaga do konsultowanego projektu aktu'
};

export const irspaDetailedInformationOnTheLetterContentComponentConfig: IrspaDetailedInformationOnTheLetterContentComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../tresc-pisma'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../szczegolowe-informacje-dotyczace-tresci-pisma',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const irspaWarningOnTheConsultedDraftRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    path: ':appId/tresc-pisma',
    component: IrspaLetterContentSectionComponent,
    data: irspaLetterContentComponentConfig
  },
  {
    path: ':appId/szczegolowe-informacje-dotyczace-tresci-pisma',
    component: IrspaDetailedInformationOnTheLetterContentSectionComponent,
    data: irspaDetailedInformationOnTheLetterContentComponentConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
